// Missing-fields strip — shows ✓/○ pills for the things SAVE BALL needs.
// Quick at-a-glance "what's blocking save" indicator.

// Wickets that don't have a wagon wheel because the ball never came off the
// bat (bowled, LBW, stumped, mankad, hit-wicket, retired, timed-out).
const NO_WAGON_WICKETS = new Set([
  "BOWLED", "LBW", "STUMPED", "MANKAD",
  "RETIRED", "RETIRED_HURT", "RETIRED_OUT",
  "TIMED_OUT", "HIT_WICKET",
]);

export default function MissingFieldsChips({ ball }) {
  const wicketSkipsWagon = ball?.has_wicket && NO_WAGON_WICKETS.has(ball?.wicket_type);
  const items = [
    { k: "runs",     ok: ball?.completed_runs != null },
    // Wagon wheel only required when the ball actually went off the bat.
    { k: "wagon",
      ok: ball?.is_dead_ball || ball?.is_wide || wicketSkipsWagon ||
          ball?.spatial?.structured_region_id ||
          ball?.spatial?.wagon_wheel_x != null,
      // Hide the chip entirely (instead of showing it as an instant ✓) when
      // the ball type can never have a wagon — less visual noise.
      hidden: ball?.is_dead_ball || ball?.is_wide || wicketSkipsWagon,
    },
  ].filter((it) => !it.hidden);
  return (
    <div className="flex items-center gap-1.5 shrink-0">
      {items.map((it) => (
        <span
          key={it.k}
          className={`text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded ${
            it.ok
              ? "bg-emerald-500/15 text-emerald-300 border border-emerald-500/30"
              : "bg-rose-500/15 text-rose-300 border border-rose-500/30"
          }`}
        >
          {it.ok ? "✓" : "○"} {it.k}
        </span>
      ))}
    </div>
  );
}
